<template>
  <div class="highEndService">
    <nav-header></nav-header>
    <div class="banner"></div>
    <section class="main sec">
      <h3 class="sec-title">高端服务</h3>
      <ul class="module-list module2">
        <li>
          <i class="icon icon1"></i>
          <div class="name">弧闪分析</div>
          <p class="desc">弧闪分析是用于评估短路故障发生时的电弧入射能量，并确定在未穿戴防火装备的人员与 可能发生弧闪的工作地点必须保持的距离</p>
        </li>
        <li>
          <i class="icon icon2"></i>
          <div class="name">选择性分析</div>
          <p class="desc">对配电系统进行全类型短路电流计算，根据计算结果校验配电设备选型是否合规，同时评 估保护系配置的合理性。</p>
        </li>
      </ul>
      <ul class="module-list module2">
        <li>
          <i class="icon icon3"></i>
          <div class="name">局部放电检测</div>
          <p class="desc">通过功能先进、使用便捷的检测设备，对电力设备的运行状态进行现场检测，找出局部放电点，为设备检修提供建议</p>
        </li>
        <li>
          <i class="icon icon4"></i>
          <div class="name">大型电动机/发电机定子绕组绝缘预期寿命分析</div>
          <p class="desc">对大型电动机/发电机进行测试，并将测试结果结合运行状态信息进行电气绝缘的系统分 析，从而来绘制绝缘恶化曲线并进行寿命预期分析。</p>
        </li>
      </ul>
    </section>
    <dark-footer></dark-footer>
  </div>
</template>
<script>
import NavHeader from '@/components/navHeader.vue'
import DarkFooter from '@/components/darkFooter.vue'
export default {
  components:{
    NavHeader,
    DarkFooter,
  },
  data(){
    return{

    }
  },
  created() {
    
  },
  methods: {
    
  },
}
</script>
<style lang="scss">
.highEndService{
  padding-top: 68px;
  .banner{
    width: 100%;
    height: 500px;
    background-image: url('~static/img/service/high-service.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  .sec{
    padding-top: 60px;
    background-color: #fff;
    .sec-title{
      font-size: 30px;
      color: #333;
      line-height: 50px;
      text-align: center;
      margin-bottom: 80px;
      &:after{
        content: "";
        display: block;
        width: 100px;
        height: 4px;
        background-color: #f75959;
        margin: 0 auto;
      }
    }
  }
  .module-list{
    overflow: hidden;
    text-align: center;
    &.module2{
      >li{
        margin-right: 226px;
        &:nth-child(2n){
          margin-right: 0;
        }
      }
    }
    >li{
      display: inline-block;
      vertical-align: top;
      margin-bottom: 80px;
      text-align: center;
      width: 288px;
    }
    .name{
      font-size: 20px;
      line-height: 30px;
      color: #f75959;
    }
    .desc{
      font-size: 16px;
      line-height: 24px;
      color: #333;
      margin-top: 8px;
      text-align: left;
    }
    .icon{
      display: inline-block;
      width: 156px;
      height: 156px;
      margin-bottom: 14px;
      background-repeat: no-repeat;
      background-size: contain;
    }
    .icon1{
      background-image: url('~@/assets/service/icon_11.png');
    }
    .icon2{
      background-image: url('~@/assets/service/icon_12.png');
    }
    .icon3{
      background-image: url('~@/assets/service/icon_13.png');
    }
    .icon4{
      background-image: url('~@/assets/service/icon_14.png');
    }
  }
}
</style>